import FlowWithProvider from "../BuildNetwork/buildNetwork";

function BuildNetwork3({ info, setGame }) {
  return <FlowWithProvider info={info} setGame={setGame} />;
}

export default BuildNetwork3;
